import axios from "axios";
import { STORAGE_KEY } from "@/store/state";

/**
 * 页面访问埋点插件
 *
 * 功能：在每次路由切换后，自动上报当前页面访问信息到后端。
 * 上报失败时会将记录写入 localStorage 队列（track_queue），后续可补偿重发。
 *
 * 使用方式：在 main.js 中 import track 后调用 Vue.use(track, router) 或直接 track(router)。
 */

// 埋点上报接口地址，可在 config/index.js 中统一配置
const TRACK_URL = "api/Common/PageVisit";

/**
 * 安装插件：注册路由后置钩子
 * @param {VueRouter} router - Vue Router 实例
 */
export default function install(router) {
    router.afterEach((to, from) => {
        try {
            // 从 localStorage 中读取持久化的用户和认证信息
            const stored = localStorage.getItem(STORAGE_KEY);
            const data = stored ? JSON.parse(stored) : {};
            const user = data.user || {};
            const auth = data.auth || {};

            // 构造埋点上报数据
            const payload = {
                routePath: to.path,               // 目标路由路径
                routeName: to.name,               // 目标路由名称
                routeQuery: to.query,             // 目标路由查询参数
                routeHash: to.hash,               // 目标路由 hash 锚点
                fromPath: from.path,              // 来源路由路径
                fromName: from.name,              // 来源路由名称
                timestamp: new Date().toISOString(), // 访问时间戳（ISO 8601）
                userId: user.userId,              // 用户 ID
                userName: user.userName,          // 用户名
                nickName: user.nickName,          // 昵称
                loginType: user.loginType,        // 登录类型
                departName: user.departName,      // 部门名称
                isLoggedIn: auth.isLoggedIn,      // 是否已登录
                isStore: !!router.app.$options.store.state.isStore, // 是否为门店模式
                userAgent: navigator.userAgent,   // 浏览器 UA
            };

            // 发送埋点请求，失败不阻塞主流程
            axios.post(TRACK_URL, payload).catch(() => {
                // 上报失败时写入本地缓存队列，避免丢失记录
                try {
                    const queue = JSON.parse(localStorage.getItem("track_queue") || "[]");
                    queue.push(payload);
                    localStorage.setItem("track_queue", JSON.stringify(queue));
                } catch (e) {}
            });
        } catch (e) {
            // 埋点异常不影响页面正常运行
            console.warn("[track] error:", e);
        }
    });
}



// WEBPACK FOOTER //
// ./src/plugins/track.js